import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import MultiLayerFilter from '../../Common/MultiLayerFilter';
import { allFilterPages } from '../../static/filterUtil';

const TrendCategory = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [selectedMultilevelData, setSelectedMultiLevelData] = useState([]);
	const multiLevelFilterStore = useSelector((store) => store.multiLevelFIlterStore);
	const currentSelectedFilterLevel = multiLevelFilterStore?.currentSelectedFilterLevel;

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setSelectedMultiLevelData(multiLevelFilterStore?.multiLevelFilters);
	}, [multiLevelFilterStore]);

	useEffect(() => {
		onFetchData();
	}, [selectedField, filterPageName]);

	const filterData = {
		[allFilterPages.TREND_RESEARCH]: dependentFilterList?.categoryList,
		[allFilterPages.MATERIAL_REQUISITION]: dependentFilterList?.fabricTypeList
	};

	const onFetchData = async () => {
		let options = filterData[filterPageName];
		setAllData(options);
		setData(options);
	};

	return (
		<MultiLayerFilter
			filterOptions={data}
			selectedField={selectedField}
			selectedMultilevelData={selectedMultilevelData}
			allOptions={allData}
			setFilterOptions={setData}
			currentSelectedFilterLevel={currentSelectedFilterLevel}
			type={filterPageName === allFilterPages.MATERIAL_REQUISITION ? 'FABRIC_TYPE' : 'TREND_CATEGORY'}
			isReplaceHyphens={true}
		/>
	);
};

export default TrendCategory;
